var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 38,
    viewBox: "0 0 29 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80274 8.33393C9.80271 4.69517 14.2037 0 14.2037 0C16.9219 5.36914 15.3037 5.20871 23.0057 11.4592C30.7077 17.7096 31.2834 30.3078 23.0057 35.4192C17.6072 38.7527 11.7466 38.9661 6.50201 35.4192C-0.840415 30.4535 -3.40013 21.8766 6.50201 13.5426C6.50201 13.5426 5.40192 14.5844 6.50209 20.8348C7.60225 27.0853 15.3041 27.0853 16.4043 20.8348C17.5045 14.5844 9.80282 18.7513 9.80274 8.33393Z",
    fill: "#FF6633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlameIcon);
export default __webpack_public_path__ + "static/media/flame-icon.2d5d7b8bca92aacc8e7a6cece3bd2060.svg";
export { ForwardRef as ReactComponent };